const VIDEO_EXT = /\.(mp4|webm|mov|m4v|ogg)(\?|$)/i;

export function isVideo(url) {
  return typeof url === "string" && VIDEO_EXT.test(url);
}

// Pick a displayable still image from a business (for cards/thumbnails)
export function thumbOf(biz, fallback) {
  if (biz?.cover && !isVideo(biz.cover)) return biz.cover;
  const media = biz?.media || [];
  const firstImg = media.find((m) => !isVideo(m));
  if (firstImg) return firstImg;
  if (biz?.logo) return biz.logo;
  return fallback;
}

// Main hero media for a business profile (image or video)
export function heroOf(biz) {
  if (biz?.featured) return biz.featured;
  const media = biz?.media || [];
  if (media.length) return media[0];
  return biz?.cover || "";
}
